module.exports = __webpack_public_path__ + "img/1526965085.7766395a.jpg";